<div
  *ngIf="authUser$ | async as user"
  class="col-span-5 space-y-4 divide-y divide-base-300 h-full w-full"
>
  <div
    class="grid grid-cols-6 gap-4 rounded-lg transition ease-out theme-hover-bg p-4"
  >
    <div>
      <div class="font-bold">Company name</div>
    </div>
    <div class="col-span-5 space-y-6">
      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Logo</div>
        </div>
        <div class="col-span-2">
          <nz-spin [nzSpinning]="uploading">
            <div class="avatar">
              <div
                class="mb-8 rounded-btn w-24 h-24 ring theme-border ring-offset-base-100 ring-offset-2"
              >
                <img
                  [src]="user?.company?.logoUrl || 'logo-placeholder.jpg'"
                  alt="company logo"
                />
              </div>
            </div>
          </nz-spin>

          <div class="mt-4">
            <input (change)="upload($event)" type="file" />
          </div>
        </div>
        <div
          (click)="showEditCompanyNameModal = true"
          class="flex justify-end text-xl text-gray-500 cursor-pointer"
        >
          <div><span class="fe fe-edit-2 cursor-pointer"></span></div>
        </div>
      </div>
      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Name</div>
        </div>
        <div class="col-span-3">
          <ng-container
            *ngIf="user && user.company && user.company.name; else skeleton"
          >
            {{ user.company.name }}
          </ng-container>
          <ng-template #skeleton>
            <div class="skeleton w-32 h-4"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div
    class="grid grid-cols-6 gap-4 rounded-lg transition ease-out theme-hover-bg p-4"
  >
    <div>
      <div class="font-bold">Company Information</div>
    </div>
    <div class="col-span-5 space-y-8">
      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Email</div>
        </div>
        <div class="col-span-2">
          {{ user.company.email || 'N/A' }}
        </div>
        <div
          (click)="showEditCompanyInfoModal = true"
          class="flex justify-end cursor-pointer text-xl text-gray-500"
        >
          <div><span class="fe fe-edit-2"></span></div>
        </div>
      </div>
      
      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Representative Email</div>
        </div>
        <div class="col-span-3">
          {{ user.email || 'N/A' }}
        </div>
      </div>

      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Phone Number</div>
        </div>
        <div class="col-span-3">
          {{ (user.company.phoneNumber || user.phoneNumber) | phoneFormat }}
        </div>
      </div>

      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Registration Date</div>
        </div>
        <div class="col-span-3">
          {{ user.company.createdAt | date: 'medium' }}
        </div>
      </div>

      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Status</div>
        </div>
        <div class="col-span-3">
          <ng-container *ngIf="user.company.status; else noStatus">
            <span 
              class="badge" 
              [class.badge-success]="user.company.status === 'Active'"
              [class.badge-warning]="user.company.status !== 'Active'">
              {{ user.company.status }}
            </span>
          </ng-container>
          <ng-template #noStatus>N/A</ng-template>
        </div>
      </div>

      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Timezone</div>
        </div>
        <div class="col-span-3">
          <ng-container *ngIf="tenantSettingsQuery.data() as settings; else loadingTimezone">
            {{ settings.timezone }}
          </ng-container>
          <ng-template #loadingTimezone>
            <div class="skeleton w-32 h-4"></div>
          </ng-template>
        </div>
      </div>

      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Currency</div>
        </div>
        <div class="col-span-3">
          <ng-container *ngIf="tenantSettingsQuery.data() as settings; else loadingCurrency">
            {{ settings.currency }}
          </ng-container>
          <ng-template #loadingCurrency>
            <div class="skeleton w-32 h-4"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div
    class="grid grid-cols-6 gap-4 rounded-lg transition ease-out theme-hover-bg p-4"
  >
    <div>
      <div class="font-bold">Address</div>
    </div>
    <div class="col-span-5 space-y-8">
      <tenant-letterhead-settings></tenant-letterhead-settings>

      <div class="grid grid-cols-4">
        <div>
          <div class="font-semibold">Company Country</div>
        </div>
        <div class="col-span-3">
          <ng-container *ngIf="tenantSettingsQuery.data() as settings; else loadingCountry">
            {{ settings.country }}
          </ng-container>
          <ng-template #loadingCountry>
            <div class="skeleton w-32 h-4"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div
    class="grid grid-cols-6 gap-4 rounded-lg transition ease-out theme-hover-bg p-4"
  >
    <div>
      <div class="font-bold">Communications with BusPro</div>
    </div>
    <div class="col-span-5 space-y-8">
      <div class="grid grid-cols-4">
        <div>
          <div class="capitalize font-semibold cursor-pointer text-blue-600">
            View Privacy Statement
          </div>
        </div>
        <div class="col-span-3"></div>
      </div>
    </div>
  </div>

  <tenant-change-company-name-modal
    (hide)="showEditCompanyNameModal = false"
    [show]="showEditCompanyNameModal"
    [user]="user!"
  ></tenant-change-company-name-modal>

  <tenant-update-company-info-modal
    (hide)="showEditCompanyInfoModal = false"
    [show]="showEditCompanyInfoModal"
    [user]="user!"
  ></tenant-update-company-info-modal>
</div>
